import api from '../../api';
// 登录
export function login(params) {
  return api.post('/user/login', params).then(res => res);
}
// 获取数据字典
export function getDictionaryList(params) {
  return api.post('/dic/getdiclist.html', params).then(res => res);
}
// 获取数据字典ID获取数据字典项
export function getdiclistbypid(params) {
  return api.post('/dic/getdiclistbypid.html', params).then(res => res);
}
// 获取验证码
export function getVerify(params) {
  return api.get('/log/getVerify', params).then(res => res);
}
// 获取登录信息
export function getUser(params) {
  return api.post('/user/getUser.go', params, false, false).then(res => res);
}
// 获取登录信息
export function upUser(params) {
  return api.post('/user/upUser.go', params).then(res => res);
}
// 重置密码
export function upPass(params) {
  return api.post('/user/upPass.go', params).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/adminApi/zh/login.js